import { render, staticRenderFns } from "./AttachmentsPrintGrid.vue?vue&type=template&id=6617ccd0"
import script from "./AttachmentsPrintGrid.vue?vue&type=script&lang=js"
export * from "./AttachmentsPrintGrid.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsPrintGrid.vue?vue&type=style&index=0&id=6617ccd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports